import React from 'react';
import type { DeclinedImmunizationModel } from './types';
import {
	type DeletePatientDeclinedImmunizationCommand,
	deletePatientDeclinedImmunizationOptions,
	getImmunizationsOptions,
	ImmunizationTypeEnum
} from '@generated';
import { useMutation } from '~/util/http/useMutation';
import { DataTable } from '~/shared/data-tables/DataTable';
import { DeclinedImmunizationFormModal } from './forms/DeclinedImmunizationFormModal';
import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';
import { TableActions } from '~/shared/data-tables/TableActions';

function RenderActionsCell(props: DeclinedImmunizationModel) {
	const deleteImmunizaion = useMutation<void, DeletePatientDeclinedImmunizationCommand>({
		...deletePatientDeclinedImmunizationOptions,
		invalidateQueryKeys: [getImmunizationsOptions(props.stayId).queryKey]
	});
	const onRemove = () => {
		if (confirm('Are you sure you want to remove this immunization?')) {
			deleteImmunizaion.mutate({ stayId: props.stayId, declinedImmunizationId: props.id });
		}
	};
	return (
		<TableActions>
			<TableActions.ViewButton
				renderModal={closeModal => (
					<DeclinedImmunizationFormModal stayId={props.stayId} existingImmunization={props} closeModal={closeModal} />
				)}
			/>
			<TableActions.DeleteButton onClick={onRemove} isPending={deleteImmunizaion.isPending} />
		</TableActions>
	);
}

const columns: DataTableColumnProps<DeclinedImmunizationModel>[] = [
	{
		key: 'immunizationTypeLabel',
		header: 'Type',
		renderCell: d => (d.immunizationTypeId === ImmunizationTypeEnum.Other ? d.immunizationTypeOther : d.immunizationTypeLabel)
	},
	{
		key: 'dateDeclined',
		header: 'Date Declined',
		renderCell: d => (d.dateDeclined ? new Date(d.dateDeclined).toLocaleDateString() : 'N/A')
	},
	{
		key: 'Reason',
		header: 'reasonForDecline'
	},
	{
		key: 'actions',
		header: 'Actions',
		width: 'w-24',
		renderCell: d => <RenderActionsCell {...d} />
	}
];

export function DeclinedImmunizationsTable({ rows }: { rows: DeclinedImmunizationModel[] }) {
	return (
		<DataTable
			columns={columns}
			rows={rows}
			viewMore={{
				text: 'View Additional Declined Immunizations',
				threshold: 3
			}}
		/>
	);
}
